__turbopack_context__.v({
  "field": "styles-module-scss-module__S6wTKa__field",
});
